import { Component, ElementRef, OnInit, Renderer2, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ReCaptchaComponent, ReCaptchaService } from "angular-recaptcha3";
import { ButtonComponent, ItemData } from "sharedGuiSmall/components";
import { LicensePackageOptions, LicensePackageType } from "sharedGuiSmall/enums";
import { ValidationMessage } from "sign-up-app/interfaces/ValidationMessage";
import { AuthAppService } from "sign-up-app/services/auth.service";
import { RegisterUser } from "sign-up-app/sign-up/RegisterUser";

declare var grecaptcha: ReCaptchaComponent;

@Component({
	selector: 'invite-box',
	templateUrl: './invitebox.component.html',
	styleUrls: ['./invitebox.component.less', '../../forms_style.less']
})
export class InviteboxComponent implements OnInit{

	@ViewChild('pwdHints')
	private pwdHints!: ElementRef<HTMLDivElement>;

	@ViewChild('passwordInput')
	private passwordInput!: ElementRef<HTMLInputElement>;

	@ViewChild('passwordWrongMsg')
	private passwordWrongMsg!: ElementRef<HTMLDivElement>;

	@ViewChild('positionWrongMsg')
	private positionWrongMsg!: ElementRef<HTMLDivElement>;

	@ViewChild('signUpBtn')
	private signUpBtn!: ButtonComponent;

	returnToSignIn: string = 'sign-in'
	emailAddress: string | null = '';

	positions: Array<ItemData> = [{ id: 7, value: 'other', disabled: false }];
	newUser = new RegisterUser();
	
	fullLiveUrl = window.fullLiveUrl;
	fullLandingUrl = window.fullLandingUrl
	hasInvite: boolean = false;
	
	isPasswordValid: boolean = false;
	isPositionValid: boolean = false;
	isValidEmail: boolean = false;
	
	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private authService: AuthAppService,
		private recaptchaService: ReCaptchaService,
		private render: Renderer2
	) {

	}
	
	ngOnInit() {
		this.getEmailAddress();
		
		this.authService.LoadPositions();

		if (this.authService.positionsPromise)
			this.authService.positionsPromise.then(data => {
				if (typeof (data.data?.Positions) == "undefined") return;
				this.positions = this.getComboItems(data.data.Positions);

				const url = window.location.href;

				if (url.indexOf('http_referer=') !== -1) {

					let tokens = url.split('&');
					console.warn('tokens', tokens);

					if (tokens && tokens.length > 1) {
						const position = tokens[1].split('your_role=')[1].replace(/\+/g, " ");
						
						this.newUser.selectedPositionId = this.positions.find(x => x.value.toLowerCase() === position.toLowerCase())?.id ?? 7; //7 - default value for "other" position

						localStorage.setItem('selectedPositionId', this.newUser.selectedPositionId + '');
					}
				}
			});
	}

	signUp(): void {
		this.validatePassword();
		this.isPositionValid = this.validateField('positions', this.newUser.selectedPositionId + '', ['required'], { 'required': 'The position field must be completed' });

		if (this.isPasswordValid && this.isPositionValid) {
			this.recaptchaService.execute();
		}
		else {
			console.error('validation failed');
		}
	}

	private async getEmailAddress(){
		this.emailAddress = this.route.snapshot.paramMap.get('email');

		if(this.emailAddress != null){
			this.isValidEmail = this.authService.ValidateEmail(this.emailAddress)

			if (this.isValidEmail) {
				const result = await this.authService.isUserHasInvites(this.emailAddress);

				this.hasInvite = result;
			}
		}
	}
	
	get isEmailEmpty(): boolean{
		return this.emailAddress != null;
	}

	toggleGetNews(): void {
		this.newUser.getNews = !this.newUser.getNews;
	}

	getComboItems(itemsDto: any): ItemData[] {
		let result = [];
		if (itemsDto)
			for (let i = 0; i < itemsDto.length; i++) {
				let item = new ItemData();
				item.id = itemsDto[i].ID === 0 ? -1 : itemsDto[i].ID;
				item.value = itemsDto[i].Name;
				result.push(item);
			}

		return result;
	}

	goToSignIn() {
		this.router.navigate([this.returnToSignIn], { skipLocationChange: false });
	}
	
	goToLanding(): void {
		window.location.href = this.fullLandingUrl;
	}
	
	onPasswordType() {
		this.authService.ProcessPasswordHints(this.newUser.passwordStr, this.pwdHints, 8);
	}

	validatePassword(): void {
		this.isPasswordValid = this.validateField('password', this.newUser.passwordStr, ['required', 'minlength 8', 'uppercase', 'lowercase', 'special', 'maxlength 48'],
			{
				'required': 'The Password field must be completed', 'minlength': 'Minimum password length 8 characters', 'uppercase': 'Does not meet password requirements',
				'lowercase': 'Does not meet password requirements', 'special': 'Does not meet password requirements',
				'maxlength': 'Maximum password length 48 characters'
			});
	}

	validatePositions(): void {
		if (this.newUser.selectedPositionId)
			this.isPositionValid = this.validateField('positions', this.newUser.selectedPositionId + '', ['required'], { 'required': 'The position field must be completed' });
	}

	validateField(validationType: string, value: string, validations: Array<string>, validationMessages: ValidationMessage): boolean {

		let isValid = true;
		switch (validationType) {
			case 'password':
				isValid = this.authService.ValidateField(this.passwordInput, this.passwordWrongMsg, value, validations, validationMessages); break;
			case 'positions':
				isValid = this.authService.ValidateField(undefined, this.positionWrongMsg, value, validations, validationMessages); break;
		}

		return isValid;
	}
	
	enableBtns(): void {
		this.render.removeStyle(this.signUpBtn.getElDom(), 'pointer-events');
	}

	disableBtns(): void {
		this.render.setStyle(this.signUpBtn.getElDom(), 'pointer-events', 'none');
	}

	onCaptchaResponse(token: string): void {
		this.disableBtns();
		this.authService.toggleSpinner();
		this.newUser.captchaText = token;

		this.newUser.password = this.newUser.passwordStr;
		this.newUser.email = this.emailAddress!;
		this.newUser.isFree = true;

		localStorage.setItem("brixx-email", this.newUser.email);
		localStorage.setItem('packageTypeRegistration', LicensePackageOptions.get(LicensePackageType.BrixxFree)!.OptionName);

		const newUser = JSON.stringify(this.newUser);
		this.authService.RegisterUser(newUser).then((res: string) => {
			let data = { newUserId: 0, userHasInvites: false, companyToWhichUserInvited: '', invitedCompanyId: 0, success: false, errorMessage: '' };
			this.enableBtns();
			this.authService.toggleSpinner();
			if (res && res.length) {
				data = JSON.parse(res);
				if (data.success && !data.errorMessage) {
					localStorage.setItem('selectedCompanyId', data.invitedCompanyId.toString());
					this.authService.toAccount();
				} else {
					if (this.passwordInput && this.passwordWrongMsg)
						this.authService.AddErrorMessage(this.passwordInput, this.passwordWrongMsg, data.errorMessage);
					grecaptcha.reset();
				}
			}
		}).catch((reason: string) => {
			console.log('RegisterUser error', reason);
			this.enableBtns();
			this.authService.toggleSpinner();

			if (this.passwordInput && this.passwordWrongMsg)
				this.authService.AddErrorMessage(this.passwordInput, this.passwordWrongMsg, 'Unknown register user server error');
			grecaptcha.reset();
		});
	}
}